import {ChangeDetectorRef, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Config, DatePicker} from '../../../models/config';
import {FormGroup, Validators} from '@angular/forms';
import {DateComparable, SetOptions, WidgetPositioning} from 'eonasdan-bootstrap-datetimepicker';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import {DateTimeFormatService} from '../../..';
import * as moment from 'moment';
import {Moment} from 'moment';
import {SearchSupportListAction} from '../../../../report/actions/support-list';
import {BsLocaleService} from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'storever-form-date-range-picker',
  templateUrl: './form-date-range-picker.component.html',
  styleUrls: ['./form-date-range-picker.component.scss']
})
export class FormDateRangePickerComponent implements OnInit , OnDestroy {

  config: Config;
  group: FormGroup;
  startDateOptions: SetOptions;
  isAdd: boolean;
  isEdit: boolean;
  isExchange: boolean;
  init: boolean;
  orderType: number;
  dayToExclude: number[];
  localeDate = 'FR';
  // private
  minDate: DateComparable | boolean;
  maxDate: DateComparable | boolean;
  defaultDate: DateComparable;
  useCurrent: boolean;
  endLessDate = false ;
  dateToShow: string;
  // tslint:disable-next-line:no-any
  defaultValue: any;

  // tslint:disable-next-line:no-any
  ranges: any = [{
    value: [new Date(new Date().setDate(new Date().getDate() - 7)), new Date()],
    label: 'Last 7 Days'
    },
                 {
      value: [new Date(new Date().setDate(new Date().getDate() - 30)) , new Date()],
      label: 'Last Month'
    }];

  get isDisabled(): boolean {
    return this.group.disabled;
  }

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale,
              private cdr: ChangeDetectorRef,
              private localeService: BsLocaleService,
              private dateTimeFormatService: DateTimeFormatService) {
    this.dayToExclude = [0, 6];
  }

  ngOnInit(): void {


    this.localeService.use(this.localeDate);
    this.minDate = new Date(2020, 0);
    this.minDate.setDate(this.minDate.getDate());
    if (this.group.get(this.config.controlName[0]).value && this.group.get(this.config.controlName[1]).value) {
      this.defaultValue = [ moment(this.group.get(this.config.controlName[0]).value).format('DD/MM/YYYY' ) ,
                            moment(this.group.get(this.config.controlName[1]).value).format('DD/MM/YYYY' )];
    }



  }

  ngOnDestroy(): void {
  }


  // tslint:disable-next-line:no-any
  checkboxChange(event: any): void {
    if (event.target.checked) {
      this.endLessDate = true;
      this.group.get(this.config.controlName[0]).clearValidators();
      this.group.get(this.config.controlName[0]).updateValueAndValidity();
      this.group.get(this.config.controlName[0]).patchValue(null);
      this.group.get(this.config.controlName[0]).disable();
    } else {
      this.endLessDate = false;
      this.group.get(this.config.controlName[0]).enable();
      this.group.get(this.config.controlName[0]).setValidators([Validators.required]);
      this.group.get(this.config.controlName[0]).updateValueAndValidity();
      if (moment(this.group.get(this.config.controlName[0]).value).format('YYYY-MM-DD') === '2099-12-31' ||
        !this.group.get(this.config.controlName[0]).value) {
        // this.group.get(this.config.controlName[0]).patchValue(moment().format('YYYY-MM-DD'));
        this.cdr.detectChanges();
      }
    }

  }
  applyFilter(query: string): void {
    if (query) {
       this.group.get(this.config.controlName[0]).setValue(moment(query[0]).format('YYYY-MM-DD'));
       this.group.get(this.config.controlName[1]).setValue(moment(query[1]).format('YYYY-MM-DD'));
    }

    this.group.get(this.config.controlName[1]).valueChanges.subscribe((value) => {
        if (!value) {
          this.defaultValue = null;
        }

      })

  }

}

